import { useState } from "react";
import { supabase } from "../supabaseClient";

export function useExamResults() {
  const [examResult, setExamResult] = useState(null);
  const [loadingExamResult, setLoadingExamResult] = useState(false);

  const fetchExamResult = async (examSessionId) => {
    if (!examSessionId) return;

    setLoadingExamResult(true);

    const { data: attempts, error: attemptsError } = await supabase
      .from("exam_attempts")
      .select("id, user_id, score, total_questions, accuracy_pct, attempt_status")
      .eq("exam_session_id", examSessionId)
      .eq("attempt_status", "submitted");

    if (attemptsError) {
      alert(attemptsError.message);
      setLoadingExamResult(false);
      return;
    }

    const attemptIds = attempts.map((a) => a.id);

    if (attemptIds.length === 0) {
      setExamResult({
        submittedCount: 0,
        classAverage: null,
        mostMissedQuestions: [],
      });
      setLoadingExamResult(false);
      return;
    }

    const { data: answers, error: answersError } = await supabase
      .from("exam_answers")
      .select("question_id, is_correct")
      .in("attempt_id", attemptIds);

    if (answersError) {
      alert(answersError.message);
      setLoadingExamResult(false);
      return;
    }

    const avg =
      attempts.reduce((sum, a) => sum + Number(a.accuracy_pct || 0), 0) /
      attempts.length;

    const missedMap = {};

    answers.forEach((answer) => {
      if (answer.is_correct === false) {
        missedMap[answer.question_id] =
          (missedMap[answer.question_id] || 0) + 1;
      }
    });

    const mostMissedQuestions = Object.entries(missedMap)
      .map(([questionId, missedCount]) => ({
        questionId,
        missedCount,
        incorrectRate: Math.round((missedCount / attempts.length) * 100),
      }))
      .sort((a, b) => b.missedCount - a.missedCount);

    setExamResult({
      submittedCount: attempts.length,
      classAverage: Math.round(avg),
      mostMissedQuestions,
    });

    setLoadingExamResult(false);
  };

  return {
    examResult,
    loadingExamResult,
    fetchExamResult,
  };
}